// src/components/community/ThreadTags.js
import React from 'react';
import './ThreadTags.css';

// Simplified version with no click handling to avoid errors
const ThreadTags = ({ tags, size = 'normal' }) => {
  if (!tags || tags.length === 0) return null;
  
  return (
    <div className={`thread-tags ${size === 'small' ? 'thread-tags-small' : ''}`}>
      {tags.map((tag, index) => (
        <span 
          key={`${tag}-${index}`}
          className="thread-tag"
          // No onClick handler to avoid errors
        >
          #{tag}
        </span>
      ))}
    </div>
  );
};

export default ThreadTags;